<template>
    <Modal
        ref="modalRef"
        :name="name"
        :primary-button-disabled="!canConfirm"
        :primary-button-label="primaryButtonLabel"
        :processing="processing"
        max-width="lg"
        title="Confirm permission changes"
        @submit="$emit('confirm')"
    >
        <p v-if="changes.length === 0" class="text-gray-500">No pending changes.</p>
        <ul v-else class="mb-0 list-none p-0">
            <li v-for="(change, index) in changes" :key="index" class="mb-2">
                <strong>{{ change.role_label }}:</strong>
                <span class="ms-1">
                    <template v-if="change.kind === 'reset'">
                        reset {{ permissionLabel(change) }} ({{ change.previous_override }} override removed)
                    </template>
                    <template v-else>
                        <span :class="change.action === 'grant' ? 'text-green-600' : 'text-red-600'">{{
                            change.action === 'grant' ? 'grant' : 'revoke'
                        }}</span>
                        {{ permissionLabel(change) }} ({{ change.was_default ? 'default' : 'previously overridden' }})
                    </template>
                </span>
            </li>
        </ul>
    </Modal>
</template>

<script setup>
import { computed, ref } from 'vue';
import Modal from '@/Components/Modal.vue';

const props = defineProps({
    name: { type: String, default: 'confirm-permission-changes' },
    changes: { type: Array, default: () => [] },
    processing: { type: Boolean, default: false },
});

defineEmits(['confirm']);

const modalRef = ref(null);

const canConfirm = computed(() => props.changes.length > 0);
const primaryButtonLabel = computed(() => `Apply ${props.changes.length} change${props.changes.length === 1 ? '' : 's'}`);

function permissionLabel(change) {
    return change.permission_description ?? change.permission;
}

defineExpose({
    close: () => modalRef.value?.close(),
});
</script>
